import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import L from 'leaflet';
import { Home, Building2, Landmark, Store, Warehouse, HeartHandshake } from 'lucide-react';

export const BUILDING_TYPES = [
    { value: 'maison', label: 'Maison', Icon: Home },
    { value: 'immeuble', label: 'Immeuble', Icon: Building2 },
    { value: 'public', label: 'Bâtiment public', Icon: Landmark },
    { value: 'commerce', label: 'Commerce / entreprise', Icon: Store },
    { value: 'agricole', label: 'Bâtiment agricole / hangar', Icon: Warehouse },
];

export const BUILDING_STATES = [
    { value: 'intact', label: 'Intact', color: '#3d8a5c' },
    { value: 'endommage_habitable', label: 'Endommagé habitable', color: '#b69526' },
    { value: 'endommage_inhabitable', label: 'Endommagé inhabitable', color: '#bd622c' },
    { value: 'sinistre', label: 'Sinistré', color: '#c0473e' },
    { value: 'brule', label: 'Brûlé', color: '#5c2a14' },
    { value: 'detruit', label: 'Détruit', color: '#11151b' },
];

// Profils autorises a dessiner et poser des reperes (identique au backend EDIT_ROLES)
export const MAP_EDIT_ROLES = ['chef_dispositif', 'logistique', 'moyen', 'secouriste', 'equipier', 'soutien_log_commune',
    'secretariat_communication', 'police_municipale', 'cos', 'operateur_radio', 'soutien_psy'];

export const typeOf = (v) => BUILDING_TYPES.find((t) => t.value === v) || BUILDING_TYPES[0];
export const stateOf = (v) => BUILDING_STATES.find((s) => s.value === v) || BUILDING_STATES[0];

const iconCache = new Map();

const pinIcon = (Icon, color, key) => {
    if (iconCache.has(key)) return iconCache.get(key);
    const svg = renderToStaticMarkup(<Icon size={16} color="#ffffff" strokeWidth={2} />);
    const icon = L.divIcon({
        className: 'civis-map-pin',
        html: `<div style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:${color};border:2px solid #ffffff;box-shadow:0 1px 3px rgba(0,0,0,.45);">${svg}</div>`,
        iconSize: [28, 28],
        iconAnchor: [14, 14],
        popupAnchor: [0, -14],
    });
    iconCache.set(key, icon);
    return icon;
};

export const buildingIcon = (type, state) => pinIcon(typeOf(type).Icon, stateOf(state).color, `${type}-${state}`);

export const careIcon = pinIcon(HeartHandshake, '#25599b', 'care');
